import baguetteBox from 'baguettebox.js';
import 'baguettebox.js/dist/baguetteBox.min.css!';


class Gallery {

	constructor(){  
	    this._init();
	}

	_init(){

	  document.addEventListener('DOMContentLoaded', (event) => {
	    baguetteBox.run('[data-trigger="gallery"]');
	  });
	}

}

export const gallery = new Gallery();